import React, { useState, useEffect, Fragment } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UserProfileHook from "../hooks/UserProfileHook";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const UserProfileRequest = ({ schoolId, pathwayEmail, opEmail }) => {
  const { postData } = UserProfileHook();
  const [formData, setFormData] = useState({
    schoolId: schoolId,
    schoolName: "",
    fromName: "",
    name: "",
    email: "",
    title: "",
    comments: "",
    pathwayEmail: pathwayEmail, // Initialize with prop values
    opEmail: opEmail,
  });

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Submission loading state
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      pathwayEmail: pathwayEmail, // Update if props change
      opEmail: opEmail,
    }));
  }, [pathwayEmail, opEmail]); // Add to dependency array

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true during submission
    try {
      await postData(formData);
      setSnackbarOpen(true);
      setLoading(false); // Set loading back to false after submission
      handleClose(); // Close the dialog after successful submission
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false); // Set loading to false if error occurs
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setLoading(false);
    setFormData({
      schoolId: schoolId,
      schoolName: "",
      fromName: "",
      name: "",
      email: "",
      title: "",
      comments: "",
      pathwayEmail: pathwayEmail, // Keep emails on close
      opEmail: opEmail, // Keep emails on close
    });
  };
  return (
    <Fragment>
      <Button
        variant="contained"
        color="success"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ color: "white" }}
      >
        User Profile Request
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <ModalDialogTitle onClose={handleClose}>
          User Profile Request
        </ModalDialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : (
            <form onSubmit={handleSubmit}>
              <input type="hidden" name="schoolId" value={formData.schoolId} />
              <TextField
                label="School Name"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="From Name"
                name="fromName"
                value={formData.fromName}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Request Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Comments"
                name="comments"
                value={formData.comments}
                onChange={handleChange}
                fullWidth
                margin="normal"
                multiline
                rows={4}
              />
            </form>
          )}
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} saveLabel="Submit" />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Request has been sent.
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default UserProfileRequest;
